import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { NAMESPACES } from '~/i18n/namespaces';
import HBModal from '@honeybook/hbui/dist/components/HBModal/HBModal';
import HBMediaElement from '@honeybook/hbui/dist/components/HBMediaElement/HBMediaElement';
import HBText from '@honeybook/hbui/dist/components/HBText/HBText';
import { IAction } from '@honeybook/hbui/dist/components/HBModal/HBModal';

interface Props {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: () => void;
}

const NonUsaOrCanadaWarningModal = ({ isOpen, onClose, onConfirm }: Props) => {
    const { t } = useTranslation(NAMESPACES.CLIENT_EXPERIENCE, {
        keyPrefix: 'public_template.international_modal'
    });

    const actions: IAction[] = [
        {
            text: t('not_based_cta'),
            testIdName: 'not-based-button',
            onClick: onClose,
            theme: 'secondary-solid-primary'
        },
        {
            text: t('is_based_cta'),
            testIdName: 'is-based-button',
            onClick: onConfirm
        }
    ];

    return (
        <StyledModal
            isOpen={isOpen}
            closeIconColor="neutral900"
            onClose={onClose}
            actions={actions}
            actionsAlignment="center"
            testId={'international-availability-modal'}
        >
            <BodyContainer>
                <Illustration
                    path="illustrations/earth.png"
                    width={60}
                    height={60}
                />
                <Title type="title20" weight="bold" align="center">
                    {t('title')}
                </Title>
                <HBText type="body14" align="center">
                    {t('description')}
                </HBText>
            </BodyContainer>
        </StyledModal>
    );
};

export default NonUsaOrCanadaWarningModal;

// -------------------------------- Styles -------------------------------- //

const StyledModal = styled(HBModal)`
    display: flex;
    flex-direction: column;
    align-items: center;
    max-width: 400px;
`;

const BodyContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
`;

const Illustration = styled(HBMediaElement)`
    margin-bottom: 20px;
`;

const Title = styled(HBText)`
    margin-bottom: 8px;
`;
